import { performRequest_GET, performRequest_PUT, performRequest_POST } from '@/platform/utils/http/httpService'
import { getServerApi } from '@/config/deployment'
import { getAnyFirebaseToken, getCurrentUserToken } from '../../auth/services/authService'

let envUri = getServerApi()
const accountUri = envUri + '/api/accounts/details'
const accountPublicDetailsUri = envUri + '/api/accounts/public/details'
const invitesUri = envUri + '/api/accounts/invites'
const inviteUserUri = envUri + '/api/user/v2/invites'
const tenantInviteUri = envUri + '/api/accounts/tenant/invite';
const privateFilesUri = `${envUri}/api/accounts/private-files`;

const getInvitationByEncryptedId = (encInviteId) => {
    return new Promise((resolve, reject) => {
        if (!encInviteId) reject("missing encInviteId");
        else {
            getAnyFirebaseToken()
                .then(token => {
                    var headers = { "Authorization": token };
                    return performRequest_GET(inviteUserUri, { encInviteId: encInviteId }, headers)
                })
                .then(resp => {
                    if (resp.success) resolve(resp.response.data.body)
                    else reject(resp.error)
                })
                .catch(err => {
                    reject(err)
                })
        }
    })
}
const updateAccountDetails = (accountId, updates) => {
    return new Promise((resolve, reject) => {
        getCurrentUserToken()
            .then(token => {
                var headers = { "Authorization": token };
                return performRequest_PUT(accountUri + "/" + accountId, updates, headers)
            })
            .then(resp => {
                if (resp.success) resolve(resp.response.data.body)
                else reject(resp.error)
            })
            .catch(err => {
                reject(err)
            })
    })
}
const getAccountPublicDetails = (accountId) => {
    return new Promise((resolve, reject) => {
        if (!accountId) reject("missing accountId");
        else {
            getCurrentUserToken()
                .then(token => {
                    var headers = { "Authorization": token };
                    return performRequest_GET(accountPublicDetailsUri + "/" + accountId, {}, headers)
                })
                .then(resp => {
                    if (resp.success) resolve(resp.response.data.body)
                    else reject(resp.error)
                })
                .catch(err => {
                    reject(err)
                })
        }
    })
}

const getAccountDetails = (accountId) => {
    return new Promise((resolve, reject) => {
        if (!accountId) reject("missing accountId");
        else {
            getCurrentUserToken()
                .then(token => {
                    var headers = { "Authorization": token };
                    return performRequest_GET(accountUri + "/" + accountId, {}, headers)
                })
                .then(resp => {
                    if (resp.success) resolve(resp.response.data.body)
                    else reject(resp.error)
                })
                .catch(err => {
                    reject(err)
                })
        }
    })
}

const getAccountInvites = (accountId) => {
    return new Promise((resolve, reject) => {
        if (!accountId) reject("missing accountId");
        else {
            getCurrentUserToken()
                .then(token => {
                    var headers = { "Authorization": token };
                    return performRequest_GET(invitesUri + "/" + accountId, {}, headers)
                })
                .then(resp => {
                    if (resp.success) {
                        resolve(transformUserInvities_import(resp.response.data.body))
                    }
                    else reject(resp.error)
                })
                .catch(err => {
                    reject(err)
                })
        }
    })
}

const inviteTenantToDeal = ({ inviterUid, dealId, tenantAltEmail, accountId, inviteeName }) => {
    return new Promise((resolve, reject) => {
        if (!dealId) reject("missing dealId");
        else {
            getCurrentUserToken()
                .then(token => {
                    var headers = { "Authorization": token };
                    var data = {
                        inviterUid: inviterUid,
                        dealId: dealId,
                        tenantAltEmail: tenantAltEmail,
                        accountId: accountId,
                        inviteeName: inviteeName
                    }
                    return performRequest_POST(tenantInviteUri, data, headers)
                })
                .then(resp => {
                    if (resp.success) resolve(resp.response.data.body)
                    else reject(resp.error)
                })
                .catch(err => {
                    reject(err)
                })
        }
    })
}

const inviteAccountUser = ({ accountId, inviterUid, invitorName, inviteeEmail, role }) => {
    return new Promise((resolve, reject) => {
        if (!accountId) reject("missing accountId");
        else {
            getCurrentUserToken()
                .then(token => {
                    var headers = { "Authorization": token };
                    var data = {
                        invitedAccountId: accountId,
                        inviterUid: inviterUid,
                        invitorName: invitorName,
                        inviteeEmail: inviteeEmail,
                        inviteeRole: role
                    }
                    return performRequest_POST(inviteUserUri, data, headers)
                })
                .then(resp => {
                    if (resp.success) resolve(transformInvite_import(resp.response.data.body))
                    else reject(resp.error)
                })
                .catch(err => {
                    reject(err)
                })
        }
    })
}

const deleteInvite = ({ inviteId, accountId }) => {
    return new Promise((resolve, reject) => {
        if (!accountId) reject("missing accountId");
        else {
            getCurrentUserToken()
                .then(token => {
                    var headers = { "Authorization": token };
                    return performRequest_PUT(invitesUri + "/" + accountId + "?command=delete&inviteId=" + inviteId, {}, headers)
                })
                .then(resp => {
                    if (resp.success) resolve(true)
                    else reject(resp.error)
                })
                .catch(err => {
                    reject(err)
                })
        }
    })
}

const transformUserInvities_import = (invites) => {
    var transformed = []
    try {
        for (var i = 0, n = invites.length; i < n; i++) {
            transformed.push(transformInvite_import(invites[i]))
        }
        return transformed
    } catch (error) {
        return []
    }
}

const transformInvite_import = (invite) => {
    var status = invite.status
    if (invite.status == "pending") status = "pending"
    else if (invite.status == "exhausted") status = "Invite was used"

    var role = invite.inviteeRole
    if (invite.inviteeRole == "admin") role = "Administrator"
    if (invite.inviteeRole == "manager") role = "Manager"
    if (invite.inviteeRole == "viewer") role = "View only"
    if (invite.inviteeRole == "accounting") role = "Accounting"


    return {
        id: invite._id,
        email: invite.inviteeEmail,
        status: status,
        expiresAt: invite.expiresAt,
        role: role,
        createdAt: invite.createdAt
    }
}

const savePrivateFiles = async (accountId, fileNames) => {
    if (!accountId || !Array.isArray(fileNames)) {
        return false;
    }
    const token = await getCurrentUserToken();
    const response = await performRequest_POST(privateFilesUri, { accountId, fileNames }, { 'Authorization': token });

    return response.success;
};

export { getAccountPublicDetails, getAccountDetails, updateAccountDetails, getAccountInvites, inviteAccountUser, deleteInvite, getInvitationByEncryptedId, inviteTenantToDeal, savePrivateFiles }


// WEBPACK FOOTER //
// ./src/platform/account/repositories/accountRepository.js